import { useState, useEffect } from 'react';
import ProfileCard from '../../UI/ProfileCard/ProfileCard';
import { supabase } from '../../../api';
import { PROFILE_PUBLIC_HIDDEN_TABLE } from '../../../constants/supabase_constants';
import SearchIcon from '@mui/icons-material/Search';
import {
  Link,
  Box,
  Grid,
  Paper,
  InputBase,
  IconButton,
  Typography,
  InputLabel,
  MenuItem,
  FormControl,
  Select,
  Button,
} from '@mui/material';

const Body = ({ session, user }) => {
  let [users, setUsers] = useState();
  let [allUsers, setAllUsers] = useState([]);
  let [skills, setSkills] = useState('');

  useEffect(
    () => {
      fetchUsers();
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  const fetchUsers = async () => {
    let { data: users, error } = await supabase
      .from(PROFILE_PUBLIC_HIDDEN_TABLE)
      .select('*')
      .in('membershipLevel', ['member', 'member+mentor']);
    if (error) console.log(error);
    else setUsers(users);
    setAllUsers(users);
  };

  if (users === undefined) {
    return <Typography>Still loading...</Typography>;
  }

  const filterCards = (event) => {
    const value = event.target.value.toLowerCase();
    const filteredUsers = allUsers.filter((user) => `${user.fullName}`.toLowerCase().includes(value));
    setUsers(filteredUsers);
  };

  const filterSkills = (event) => {
    const value = event.target.value;
    setSkills(value);
    const filteredUsers = users.filter((user) => `${user.skills}`.includes(value));
    setUsers(filteredUsers);
  };

  const filterClear = (event) => {
    setUsers(allUsers);
    setSkills('');
  };

  return (
    <Box data-testid='container' sx={{ mt: '3rem' }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          mt: '3rem',
        }}>
        {' '}
        {user.membershipLevel !== 'member' &&
          user.membershipLevel !== 'member+mentor' &&
          user.membershipLevel !== 'mentor' && (
            <Link
              href='/payments'
              style={{
                width: '100%',
                textDecoration: 'none',
                cursor: 'pointer',
              }}>
              <Paper
                elevation={20}
                sx={{
                  p: '2px 4px',
                  mb: '2rem',
                  width: '100%',
                  backgroundColor: 'primary.main',
                }}>
                <Typography
                  sx={{
                    ml: 1,
                    p: '10px',
                    color: 'white',
                  }}>
                  Apply to become a member of The 100 Club for access »
                </Typography>
              </Paper>
            </Link>
          )}
        {/* Search Bar */}
        <Paper
          component='form'
          sx={{
            p: '2px 4px',
            display: 'flex',
            alignItems: 'center',
            width: '100%',
          }}>
          <InputBase
            sx={{ ml: 1, flex: 1 }}
            placeholder='Search Directory'
            onInput={filterCards}
            inputProps={{ 'aria-label': 'search directory' }}
          />
          <IconButton type='submit' sx={{ p: '10px' }} aria-label='search'>
            <SearchIcon />
          </IconButton>
        </Paper>
        {/* Filter */}
        <Grid container spacing={2} sx={{ mt: '1rem' }}>
          <Grid item xs={12} lg={3}>
            <FormControl sx={{ width: '100%' }}>
              <InputLabel id='select-skills'>Skills</InputLabel>
              <Select labelId='skills' id='skills' label='Skills' value={skills} onChange={filterSkills}>
                <MenuItem value={'Bootstrapping'}>Bootstrapping</MenuItem>
                <MenuItem value={'Building a team'}>Building a team</MenuItem>
                <MenuItem value={'Content marketing'}>Content marketing</MenuItem>
                <MenuItem value={'Conversion rate optimization'}>Conversion rate optimization</MenuItem>
                <MenuItem value={'Copywriting'}>Copywriting</MenuItem>
                <MenuItem value={'Customer success'}>Customer success</MenuItem>
                <MenuItem value={'Data science'}>Data science</MenuItem>
                <MenuItem value={'Design / UX'}>Design / UX</MenuItem>
                <MenuItem value={'Email marketing'}>Email marketing</MenuItem>
                <MenuItem value={'Facebook ads'}>Facebook ads</MenuItem>
                <MenuItem value={'Go to market strategy'}>Go to market strategy</MenuItem>
                <MenuItem value={'Google ads'}>Google ads</MenuItem>
                <MenuItem value={'Growth marketing'}>Growth marketing</MenuItem>
                <MenuItem value={'Idea validation'}>Idea validation</MenuItem>
                <MenuItem value={'Link building'}>Link building</MenuItem>
                <MenuItem value={'Operations'}>Operations</MenuItem>
                <MenuItem value={'Marketing automation'}>Marketing automation</MenuItem>
                <MenuItem value={'No-code'}>No-code</MenuItem>
                <MenuItem value={'Performance marketing'}>Performance marketing</MenuItem>
                <MenuItem value={'PPC strategies'}>PPC strategies</MenuItem>
                <MenuItem value={'Pricing strategy'}>Pricing strategy</MenuItem>
                <MenuItem value={'Product analytics'}>Product analytics</MenuItem>
                <MenuItem value={'Product management'}>Product management</MenuItem>
                <MenuItem value={'Product market fit'}>Product market fit</MenuItem>
                <MenuItem value={'Public relations'}>Public relations</MenuItem>
                <MenuItem value={'Raising funding'}>Raising funding</MenuItem>
                <MenuItem value={'Sales'}>Sales</MenuItem>
                <MenuItem value={'SEO'}>SEO</MenuItem>
                <MenuItem value={'Social media'}>Social media</MenuItem>
                <MenuItem value={'User research'}>User research</MenuItem>
                <MenuItem value={'Web Development'}>Web Development</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} lg={3}>
            <Button color='primary' variant='contained' sx={{ height: '100%' }} onClick={filterClear}>
              Clear All
            </Button>
          </Grid>
        </Grid>
        {/* Profile cards */}
        <Grid container spacing={2} sx={{ mt: '3rem' }}>
          {users.map((profile) => {
            return (
              <ProfileCard
                // test
                session={session}
                membershipLevel={user.membershipLevel}
                key={profile.id}
                fullName={profile.fullName}
                title={profile.title}
                id={profile.id}
                avatar_url={profile.avatar_url}
              />
            );
          })}
        </Grid>
      </Box>
    </Box>
  );
};

export default Body;
